/**
 * Вариант TagBadge для юр. типа клиента (как в макете: ООО / ИП / ЗАО / физлицо).
 */
export function getClientTypeTagVariant (type) {
  if (type == null || type === '') return 'grey'
  const raw = String(type).trim()
  const t = raw.toLowerCase()

  if (t.startsWith('ооо') || t.includes(' ооо') || t === 'ooo') return 'blue'
  const firstWord = raw.split(/\s+/)[0]?.toLowerCase().replace(/\.$/, '') || ''
  if (
    firstWord === 'ип' ||
    firstWord.startsWith('и.п') ||
    t.includes('индивидуальный предприниматель')
  ) {
    return 'green'
  }
  if (t.includes('зао') || t.includes('оао') || t.includes('пао') || /\bао\b/.test(t)) return 'amber'
  if (t.includes('физ') || firstWord === 'фл' || firstWord.startsWith('фл.')) return 'purple'
  return 'grey'
}
